var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-container" }, [
    _c(
      "div",
      { staticClass: "modal-header" },
      [
        _c("h4", { staticClass: "modal-title" }, [
          _vm._v("Map Enterprise Agreements"),
        ]),
        _c(
          "md-button",
          {
            staticClass: "md-simple md-just-icon md-round modal-default-button",
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.$modal.hide($event)
              },
            },
          },
          [_c("md-icon", [_vm._v("clear")])],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "modal-body" },
      [
        _c(
          "form-wrapper",
          { staticClass: "form-wrapper", attrs: { validator: _vm.$v } },
          [
            _c("TeamsAutocomplete", {
              ref: "teamsRef",
              attrs: {
                label: "Team",
                placeholder: "",
                "should-focus": false,
                "is-required": true,
              },
              on: { input: _vm.searchCompleted },
            }),
          ],
          1
        ),
        _vm.team && _vm.team.teamId
          ? [
              _c("div", { staticClass: "detail-group" }, [
                _c("label", { staticClass: "label" }, [_vm._v("Company:")]),
                _c("span", { staticClass: "value" }, [
                  _vm._v(_vm._s(_vm.team.company)),
                ]),
              ]),
              _c("div", { staticClass: "detail-group" }, [
                _c("label", { staticClass: "label" }, [_vm._v("Status:")]),
                _c("span", { staticClass: "value" }, [
                  _vm._v(_vm._s(_vm.team.status)),
                ]),
              ]),
            ]
          : [_c("p", [_vm._v("No team selected")])],
        _c("p"),
        _c("p"),
      ],
      2
    ),
    _c(
      "div",
      { staticClass: "modal-footer" },
      [
        _c(
          "md-button",
          {
            staticClass: "dialog-button md-primary",
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.mapAgreements($event)
              },
            },
          },
          [_vm._v("Map Agreement/s")]
        ),
        _c(
          "md-button",
          {
            staticClass: "dialog-button md-default",
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.$modal.hide($event)
              },
            },
          },
          [_vm._v("Cancel")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }